import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { protectedResources } from 'src/app/auth/auth.config';
import { GroundControlPoint, HeightMode } from '../models/geoasset.model';
import { selectGroundControlPointById } from '../stores/gcp/gcp.selector';
@Injectable({
  providedIn: 'root',
})
export class GcpService {
  constructor(
    private http: HttpClient,
    private store: Store,
  ) {}

  public hoveredGCP: WritableSignal<GroundControlPoint | undefined> = signal<
    GroundControlPoint | undefined
  >(undefined);
  public selectedGCP: WritableSignal<GroundControlPoint | undefined> = signal<
    GroundControlPoint | undefined
  >(undefined);
  public selectedGCPList: WritableSignal<GroundControlPoint[] | undefined> =
    signal<GroundControlPoint[] | undefined>(undefined);
  public preSelectedGCPList: WritableSignal<GroundControlPoint[] | undefined> =
    signal<GroundControlPoint[] | undefined>(undefined);
  apiEndpoint: string = protectedResources.apiTodoList.endpoint;

  getGroundControlPoints() {
    const headers = new HttpHeaders({
      accept: 'application/vnd.qsconnect.geoasset.gcp.detail+json',
    });

    return this.http.get<GroundControlPoint[]>(
      `${this.apiEndpoint}/assets/geo/gcp`,
      {
        headers,
      },
    );
  }

  createGroundControlPoints(groundControlPoints: GroundControlPoint[]) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/vnd.qsconnect.geoasset.gcp.create+json',
      accept: 'application/vnd.qsconnect.geoasset.gcp.detail+json',
    });

    const createGcpRequestBody = groundControlPoints.map((gcp) => ({
      name: gcp.name,
      description: gcp.description,
      location: gcp.location,
      type: gcp.type,
      point: {
        type: 'Point',
        coordinates: gcp.point.coordinates,
      },
      height: gcp.height
        ? {
            value: gcp.height.value,
            mode: HeightMode.MSL,
          }
        : undefined,
    }));

    return this.http.post<GroundControlPoint[]>(
      `${this.apiEndpoint}/assets/geo/gcp`,
      createGcpRequestBody,
      {
        headers,
      },
    );
  }

  deleteGroundControlPoint(gcpId: string) {
    return this.http.delete(`${this.apiEndpoint}/assets/geo/gcp/${gcpId}`);
  }

  editGroundControlPoints(id: string, changes: Partial<GroundControlPoint>) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/vnd.qsconnect.geoasset.gcp.create+json',
      accept: 'application/vnd.qsconnect.geoasset.gcp.detail+json',
    });

    const updateGcpRequestBody = {
      name: changes.name,
      description: changes.description,
      location: changes.location,
      type: changes.type,
      point: {
        type: 'Point',
        coordinates: changes.point ? changes.point.coordinates : undefined,
      },
      height: changes.height
        ? {
            value: changes.height.value,
            mode: changes.height.mode,
          }
        : undefined,
    };
    return this.http.put<GroundControlPoint>(
      `${this.apiEndpoint}/assets/geo/gcp/${id}`,
      updateGcpRequestBody,
      {
        headers,
      },
    );
  }

  getSelectedGroundControlPoint(id: string): GroundControlPoint | undefined {
    let selectedGcp: GroundControlPoint | undefined;
    this.store
      .select(selectGroundControlPointById(id))
      .pipe(take(1))
      .subscribe((gcp) => {
        selectedGcp = gcp;
      });
    return selectedGcp;
  }

  reloadSelectedGcpFromStore() {
    console.log('gcp old: ', this.selectedGCP());
    if (!!this.selectedGCP()) {
      let tempGcp: GroundControlPoint = this.selectedGCP()!;
      this.selectedGCP.set(this.getSelectedGroundControlPoint(tempGcp.id));
    }
    console.log('gcp new: ', this.selectedGCP());
  }
}
